// Auth API tags
export const AUTH_API_TAGS = {
  AUTH: "auth",
} as const;

export const EMPLOYEE_API_TAGS = {
  EMPLOYEE: "employee",
} as const;

export const ORDER_API_TAGS = {
  ORDER: "order",
} as const;

export const COURSE_API_TAGS = {
  PUBLIC_COURSE: "public-course",
  COURSE: "course",
  RECOMMENDATION: "course-recommendation",
  WISHLIST: "wishlist",
} as const;

// User roles
export const USER_ROLES = {
  USER: "user",
} as const;

// API tags & role types
export type TAuthApiTags = (typeof AUTH_API_TAGS)[keyof typeof AUTH_API_TAGS];
export type TEmployeeApiTags =
  (typeof EMPLOYEE_API_TAGS)[keyof typeof EMPLOYEE_API_TAGS];
export type TCourseApiTags =
  (typeof COURSE_API_TAGS)[keyof typeof COURSE_API_TAGS];
export type TUserRoles = (typeof USER_ROLES)[keyof typeof USER_ROLES];
